var _rect, _line, _line2, _line3, _line4, _line5, _line6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardSim(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 44,
    viewBox: "0 0 64 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.00000762939,
    width: 63.9997,
    height: 43.1156,
    rx: 5,
    fill: "url(#paint0_linear_134_408)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 19.0367,
    x2: 63.9997,
    y2: 19.0367,
    stroke: "#5E5E5E"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 26.4475,
    y1: 19.5367,
    x2: 26.4475,
    y2: 0.00000190735,
    stroke: "#5E5E5E"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 46.658,
    y1: 19.5367,
    x2: 46.658,
    y2: 0.00000190735,
    stroke: "#5E5E5E"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 27.1213,
    y1: 43.1156,
    x2: 27.1213,
    y2: 29.642,
    stroke: "#5E5E5E"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 36.553,
    y1: 43.1156,
    x2: 36.553,
    y2: 19.5367,
    stroke: "#5E5E5E"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: 29.8156,
    x2: 26.9472,
    y2: 29.8156,
    stroke: "#5E5E5E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_134_408",
    x1: -2.50292e-8,
    y1: 23.9157,
    x2: 63.9997,
    y2: 25.5999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.812103,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C1C1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardSim);
export default __webpack_public_path__ + "static/media/card-sim.1fcab6cea7096d366a4e33f145af20ca.svg";
export { ForwardRef as ReactComponent };